import { getIsoDateStringAsDate, formatDate, getTimeClearedDate } from "./date-time";
import { sortByProperty } from './sort.js';

export function getTriggerDatesTooltip(triggerDates) {
    let tooltipContent = [];
    
    // Order trigger dates by day and month, ignoring the year
    let currentYear = new Date().getFullYear();
    let triggerDatesOrdered = triggerDates.map(triggerDate => {
        let triggerDateAnnual = getIsoDateStringAsDate(triggerDate.date);
        triggerDateAnnual.setFullYear(currentYear);
        return {...triggerDate, annualDate: triggerDateAnnual};
    });
    triggerDatesOrdered.sort(sortByProperty("annualDate", false));

    triggerDatesOrdered.forEach(triggerDate => {
        let tooltipString = formatDate(triggerDate.date) + " - " + getDisplayType(triggerDate.type);
        if (triggerDate.notes) {
            tooltipString += " - " + triggerDate.notes;
        }

        tooltipContent.push(tooltipString);
    });

    return { tooltipLines: tooltipContent };
}

export function isDateInTriggerDates(date, triggerDates) {
    let currentYear = new Date().getFullYear();
    let triggerDatesAnnualised = triggerDates.map(triggerDate => {
        let triggerDateAnnual = getIsoDateStringAsDate(triggerDate.date);
        triggerDateAnnual.setFullYear(currentYear);
        return {...triggerDate, annualDate: triggerDateAnnual};
    });

    return triggerDatesAnnualised.filter(triggerDate => { 
        return getTimeClearedDate(triggerDate.annualDate).getTime() === getTimeClearedDate(getIsoDateStringAsDate(date)).getTime(); 
    }).length > 0;
}

export function getTriggerDateSort(date, triggerDates) {
    if (triggerDates && triggerDates.length > 0) {
        if (isDateInTriggerDates(date, triggerDates)) {
            return 2;
        } else {
            return 1;
        }
    } else {
        return 0;
    }
}

export function getDisplayType(type) {
    if (type.includes("Birthday (Family")) {
        return "Birthday (Other)";
    } else if (type.includes("Anniversary Date (")) {
        return "Anniversary (Death)";
    } else {
        return type;
    }
}